export default "__VITE_PUBLIC_ASSET__e0c43a43__"